var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { RestService } from "../RestService";
const URL = "/auth";
export class AuthApi extends RestService {
    login(email, password, validRoles, callback) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpClient.post(`${URL}/login`, {
                email,
                password,
                validRoles
            });
            if (response.ok) {
                const token = (_a = response.data) === null || _a === void 0 ? void 0 : _a.token;
                if (!token)
                    return false;
                if (callback)
                    return yield callback(token);
                return true;
            }
            return false;
        });
    }
    register(registeringUser, callback) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpClient.post(`${URL}/register`, registeringUser);
            if (response.ok) {
                const token = (_a = response.data) === null || _a === void 0 ? void 0 : _a.token;
                if (!token)
                    return false;
                if (callback)
                    return yield callback(token);
            }
            return false;
        });
    }
    resetPassword(email, admin) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.httpClient.post(`${URL}/reset-password`, {
                email,
                admin,
            });
        });
    }
    setPassword(code, email, password) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.httpClient.post(`${URL}/set-password`, {
                code,
                email,
                password,
            });
        });
    }
    changePassword(password, newPassword) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.post(`${URL}/change-password`, {
                password,
                newPassword,
            });
            if (res.ok) {
                return true;
            }
            else {
                return false;
            }
        });
    }
}
//# sourceMappingURL=AuthApi.js.map